import type { ValueOf } from '../util/typeUtils';

export const SYSTEM_VARIABLE_RESOLVERS = {
    getAll: 'getAll',
    getBucketConfigurations: 'getBucketConfigurations',
    getSystemMailTypes: 'getSystemMailTypes',
} as const;

export type SYSTEM_VARIABLE_RESOLVER = ValueOf<typeof SYSTEM_VARIABLE_RESOLVERS>;
